module.exports = __webpack_public_path__ + "img/bhl5.567c6f3d.webp";